import { render, staticRenderFns } from "./shangpinxinxi.vue?vue&type=template&id=80be5754&scoped=true&"
import script from "./shangpinxinxi.vue?vue&type=script&lang=js&"
export * from "./shangpinxinxi.vue?vue&type=script&lang=js&"
import style0 from "./shangpinxinxi.vue?vue&type=style&index=0&id=80be5754&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80be5754",
  null
  
)

export default component.exports